import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import CreateBackendApp from './CreateBackendApp'
import MCPSignUpSetup from '../components/MCPSignUpSetup';
import { BACK4APP_DOT_COM_DASHBOARD_URL } from '../settings';
import { trackEvent } from '../utils/amplitude';

const CreateAppFlow2 = () => {
  const [showMCPSetup, setShowMCPSetup] = useState<boolean | null>(null)

  useEffect(() => {
    // Check for the signupSetupFlow cookie
    const signupFlow = Cookies.get('signupSetupFlow')
    setShowMCPSetup(signupFlow === 'mcp');
    if (signupFlow === 'mcp') {
      Cookies.remove('signupSetupFlow', { domain: 'back4app.com' })
    }
    // Cleanup function to remove cookie when component unmounts
    return () => {
      Cookies.remove('signupSetupFlow', { domain: 'back4app.com' })
    }
  }, [])

  // Show loading state while checking cookie
  if (showMCPSetup === null) {
    return null;
  }

  // Render MCPSignUpSetup if cookie exists, otherwise CreateBackendApp
  return showMCPSetup ? <MCPSignUpSetup onComplete={() => {
    Cookies.remove('signupSetupFlow');
    trackEvent('mcp activation');
    // setShowMCPSetup(false);
    window.location.href = `${BACK4APP_DOT_COM_DASHBOARD_URL}/apps`;
  }} /> : <CreateBackendApp />
}

export default CreateAppFlow2